/* 布局 */
//前台
import Layout from "@views/layout";

const topicexportRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
            {
            path: "topicexport",
            name: "TOPICEXPORT",
            meta: {
                title: "话题专家管理",
                sort: 1,
            },
            component: () => import("@views/business/topicexport/index.vue"),
            redirect: {
                name: "TOPICEXPORT_LIST",
            },
            children: [
                {
                    path: "list",
                    name: "TOPICEXPORT_LIST",
                    meta: {
                        title: "话题专家管理",
                        sort: 2,
                        keepAlive:true
                    },
                    component: () => import("@views/business/topicexport/list.vue"),
                },
                                {
                    path: "add",
                    name: "TOPICEXPORT_ADD",
                    meta: {
                        title: "新增话题专家",
                        parentPath: '/business/topicexport/list',
                        operate: true,
                    },
                    component: () => import("@views/business/topicexport/form.vue"),
                },
                                                {
                    path: "edit",
                    name: "TOPICEXPORT_EDIT",
                    meta: {
                        title: "编辑话题专家",
                        parentPath: '/business/topicexport/list',
                        operate: true,
                    },
                    component: () => import("@views/business/topicexport/form.vue"),
                },
                                        ],
    },


        ],
};

export default topicexportRouter;
